(() => {
  if (window.productCardSeriesEnhancementsInitialized) return;
  window.productCardSeriesEnhancementsInitialized = true;

  document.addEventListener('DOMContentLoaded', () => {
    function updateCouponLabel(label) {
      const svg = label.querySelector('.coupon-label__svg');
      const textElement = label.querySelector('.coupon-label__text');
      const bgPath = label.querySelector('.coupon-label__background');
      const arrowPath = label.querySelector('.coupon-label__arrow');

      if (!svg || !textElement || !bgPath || !arrowPath) {
        label.dataset.couponInitialized = 'true';
        return;
      }

      try {
        const padding = 50;
        const textWidth = textElement.getBBox().width;
        const contentWidth = textWidth + padding;
        const offset = contentWidth - 126.201168;

        bgPath.setAttribute(
          'd',
          `
            M4,0
            L${126.201168 + offset},0
            C${127.721164 + offset},0 ${129.109818 + offset},0.8615 ${129.784947 + offset},2.2233
            L${147.136217 + offset},37.2233
            C${148.11744 + offset},39.2026 ${147.308365 + offset},41.6026 ${145.329098 + offset},42.5838
            C${144.776857 + offset},42.8576 ${144.168816 + offset},43 ${143.552438 + offset},43
            L4,43
            C1.790861,43 0,41.2091 0,39
            L0,4
            C0,1.790861 1.790861,0 4,0
            Z
          `
        );

        const overlap = 16;
        const arrowX = 129.784947 + offset - overlap;

        arrowPath.setAttribute(
          'd',
          `
            M${arrowX},29
            L${arrowX + 18.222207},28.2872
            L${arrowX + 31.571533},42.443
            L${arrowX + 3.053204},60.1087
            C${arrowX + 2.114197},60.6904 ${arrowX + 0.881445},60.4007 ${arrowX + 0.299776},59.4617
            C${arrowX + 0.103817},59.1453 ${arrowX},58.7806 ${arrowX},58.4085
            V29
            Z
          `
        );

        const totalWidth = arrowX + 31.571533 + 35;
        svg.setAttribute('width', totalWidth);
        svg.setAttribute('viewBox', `0 0 ${totalWidth} 62`);
        label.dataset.couponInitialized = 'true';
      } catch (error) {
        console.warn('updateCouponLabel failed:', error);
      }
    }

    function initCouponLabels(root = document) {
      root.querySelectorAll(
        '[data-coupon-label]:not([data-coupon-initialized])'
      ).forEach(updateCouponLabel);
    }

    initCouponLabels();

    window.addEventListener('pageshow', () => {
      document.querySelectorAll('[data-coupon-label]').forEach((label) => {
        label.removeAttribute('data-coupon-initialized');
      });
      initCouponLabels();
    });

    const filterResults = document.getElementById('filter-results');
    if (filterResults && 'MutationObserver' in window) {
      const couponObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            if (node.matches('[data-coupon-label]')) {
              updateCouponLabel(node);
            }

            initCouponLabels(node);
          });
        });
      });

      couponObserver.observe(filterResults, {
        childList: true,
        subtree: true
      });
    }
  });
})();
